var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailNewsletterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "currentColor",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20.8346,
    d: "M7095 7523l142 58 2 386h-636l-3-386 144-58",
    transform: "matrix(.0922 0 0 .09295 -605.96046 -682.9347)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20.8346,
    d: "M6603 7967l318-232 318 232",
    transform: "matrix(.0922 0 0 .09295 -605.96046 -682.9347)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 20.8346,
    d: "M6603 7581l257 198M7239 7581l-259 197",
    transform: "matrix(.0922 0 0 .09295 -605.96046 -682.9347)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20.8346,
    d: "M6746 7689v-273h348v276M6853 7474h193M6792 7541h254M6792 7608h254M6792 7675h254",
    transform: "matrix(.0922 0 0 .09295 -605.96046 -682.9347)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailNewsletterIcon);
export default __webpack_public_path__ + "static/media/email-newsletter-icon.9dc376555e25ea4167ab7bed861fde55.svg";
export { ForwardRef as ReactComponent };